import classNames from 'classnames'
import React from 'react'
import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IFlowBranchLabelProps = {
  labelX: number
  labelY: number
  label: string
}

export const FlowBranchLabel = ({ labelX, labelY, label }: IFlowBranchLabelProps) => (
  <div
    style={{
      position: 'absolute',
      transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
      pointerEvents: 'all',
    }}
    className={classNames(styles.branchLabel)}
  >
    <Typography
      ariaLabel={'branchLabel'}
      ellipsis
      tooltipProps={{
        label,
      }}
    >
      {label}
    </Typography>
  </div>
)
